import moment from 'moment';
import { buildDownloadData, getCountryByCode } from '@intelligence/utils/commonUtils';
import { buildRegionCountryConfigs } from './common';
import { DataCalculation } from '@intelligence/v3/enums/download';
import { DOWNLOAD_CFG_KEY } from '@intelligence/v3/constants';

export function getMobileTopChartsRPDConfig(list: any, params: any, allParams: any) {
  const config: any = {};
  const { regionOptions = [] } = allParams || {};
  const data = list || [];
  if (!data) {
    return;
  }

  // 扁平化数据
  const groupKeys: string[] = [];
  if (allParams?.downlaod_date_method === 'separate') {
    groupKeys.push('date');
  }
  if (allParams?.region_method === 'market') {
    groupKeys.push('market');
  }
  if (allParams?.region_method === 'region') {
    groupKeys.push('region');
  }
  const targetList = [...data];
  let sortedData = [...data];
  // 排序 如果是by_time
  if (Array.isArray(targetList) && allParams?.downlaod_date_method === 'separate') {
    // 首先按照id分组
    const groupedData = targetList.reduce((acc: any, item: any) => {
      if (!acc[item.unified_id]) {
        acc[item.unified_id] = [];
      }
      acc[item.unified_id].push(item);
      return acc;
    }, {});

    // console.log('groupedDatagroupedData', groupedData);

    sortedData = [];

    // 然后对每个分组按照date降序排序
    sortedData = Object.keys(groupedData).reduce((acc: any, unified_id: any) => {
      const idList = [...groupedData[unified_id]];
      // console.log('idListidListidList1111', idList);
      idList?.sort((a: any, b: any) => {
        // 第二优先级：按 time 降序（新时间在前）
        if (b.date !== a.date) return moment(b?.date).diff(moment(a?.date));
        // 第三优先级: 国家字母升序
        const deviceCompare = a?.market?.localeCompare(b?.market);
        if (deviceCompare !== 0) return deviceCompare;
        return 0;
      });
      // console.log('idListidListidList2222', idList);
      acc.push(...idList);
      return acc;
    }, []);
    // return sortedData;

    // targetList?.sort((a: any, b: any) => {
    //   // 第一优先级：按 gameId 升序
    //   if (a.id !== b.id) return a.id - b.id;
    //   // 第二优先级：按 time 降序（新时间在前）
    //   if (b.date !== a.date) return moment(b?.date).diff(moment(a?.date));
    //   // 第三优先级: 国家字母升序
    //   const deviceCompare = a?.market?.localeCompare(b?.market);
    //   if (deviceCompare !== 0) return deviceCompare;
    //   // 第四优先级：按 device 字母升序（A-Z）
    //   return 0;
    // });
  }

  // console.log('sortedDatasortedDataList111122222', sortedData);

  // 做一个指标缓存，用于快速判断
  const metricsCache = {} as any;
  const metricList = allParams.download_metrics || [];
  metricList?.forEach((item: string) => {
    metricsCache[item] = true;
  });

  // console.log('targetListtargetList1111metricsCachemetricsCache', metricsCache);

  const regionMethod = allParams?.[DOWNLOAD_CFG_KEY.REGION_METHOD] || '';
  const isGroupByRegion = regionMethod === DataCalculation.SeparateByRegion;
  const isGroupByMarket = regionMethod === DataCalculation.SeparateByCountry;
  const regionMarketConfigs = buildRegionCountryConfigs(allParams, regionOptions);
  const regionConfigs = (() => {
    if (isGroupByRegion || isGroupByMarket) {
      return regionMarketConfigs.slice(0, 2);
    }

    return [];
  })();

  // stat 页
  const statConfig = [
    {
      title: 'Game Name',
      key: (item: any) => item?.entity_name || '',
    },
    {
      title: 'Publisher Company Name',
      key: (item: any) => item?.publisher || '',
      when: () => allParams.company_show === 1,
    },
    {
      title: 'Publisher Company HQ Name',
      key: (item: any) => item?.country_name_en || '',
      when: () => allParams.company_show === 1,
    },
    {
      title: 'Publisher Parent Company',
      key: (item: any) => item?.parent_publisher || '',
      when: () => allParams.company_show === 1,
    },
    {
      title: 'Developer Company Name',
      key: (item: any) => item?.developer_country_name_en || '',
      when: () => allParams.company_show === 1,
    },
    {
      title: 'Developer Company HQ Name',
      key: (item: any) => item?.developer_country_abbre || '',
      when: () => allParams.company_show === 1,
    },
    {
      title: 'Developer Parent Company',
      key: (item: any) => item?.developer_parent || '',
      when: () => allParams.company_show === 1,
    },
    {
      title: 'App Annie Main Genre',
      key: (item: any) => item?.genre || '',
      when: () => allParams.genre_show === 1 && params?.genre_source === 'annie',
    },
    {
      title: 'App Annie Sub Genre',
      key: (item: any) => item?.sub_genre || '',
      when: () => allParams.genre_show === 1 && params?.genre_source === 'annie',
    },
    {
      title: 'IEGG Main Genre',
      key: (item: any) => item?.iegg_genre || '',
      when: () => allParams.genre_show === 1 && params?.genre_source === 'iegg',
    },
    {
      title: 'IEGG Sub Genre',
      key: (item: any) => item?.iegg_sub_genre || '',
      when: () => allParams.genre_show === 1 && params?.genre_source === 'iegg',
    },
    {
      title: 'Release Date',
      key: (item: any) => item?.release_time || '',
      when: () => allParams.release_date_show === 1,
    },
    {
      title: 'Date',
      key: (item: any) => (params?.date_type === 'monthly' ? moment(item?.date).format('YYYY-MM') : item?.date || ''),
      when: () => allParams?.downlaod_date_method === 'separate',
    },
    ...regionConfigs,
    {
      title: 'Country_Chinese',
      key: (item: any) => getCountryByCode(item?.market, regionOptions)?.country_name_ch || item?.market || '',
      when: () => isGroupByMarket,
    },
    {
      title: 'Country_English',
      key: (item: any) => getCountryByCode(item?.market, regionOptions)?.country_name_en || item?.market || '',
      when: () => isGroupByMarket,
    },

    {
      title: 'RPD(data.ai)',
      key: (item: any) => item?.rpd || '',
      when: () => metricsCache.rpd && allParams.data_sources_value === 'appannie',
    },
    {
      title: 'Cumulative Revenue(data.ai)',
      key: (item: any) => item?.revenue || '',
      when: () => metricsCache.revenue && allParams.data_sources_value === 'appannie',
    },
    {
      title: 'Cumulative Downloads(data.ai)',
      key: (item: any) => item?.download || '',
      when: () => metricsCache.download && allParams.data_sources_value === 'appannie',
    },
    {
      title: 'RPD(Sensor Tower)',
      key: (item: any) => item?.rpd || '',
      when: () => metricsCache.rpd && allParams.data_sources_value === 'sensortower',
    },
    {
      title: 'Cumulative Revenue(Sensor Tower)',
      key: (item: any) => item?.revenue || '',
      when: () => metricsCache.revenue && allParams.data_sources_value === 'sensortower',
    },
    {
      title: 'Cumulative Downloads(Sensor Tower)',
      key: (item: any) => item?.download || '',
      when: () => metricsCache.download && allParams.data_sources_value === 'sensortower',
    },
  ];

  // console.log('targetListtargetList', targetList);

  config.stat = {
    sheetName: 'Stats',
    style: 'normal',
    data: buildDownloadData(statConfig, sortedData),
  };

  // summary 直接用二维结果写
  config.summary = {
    sheetName: 'Summary',
    style: 'summary',
    data: [
      ['Region/countries', Array.isArray(params?.regions) ? params?.regions?.join(',') : ''],
      ['Date Start', params?.start_date],
      ['Date End', params?.end_date],
    ],
  };

  return config;
}
